// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"_2D-Za","logoContainer":"_23HMB","wixLogo":"lD4Rw","inputs":"_37FtB","form":"_2OxG3","searchButton":"_1oqy1","businessNameInput":"PkYMF"};